module.exports = __webpack_public_path__ + "static/media/10.276b51fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/10.png
// module id = 1340
// module chunks = 0